
import { defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'

export default defineComponent({
  name: 'export-json-dialog',
  setup(props, { emit }) {
    const close = () => emit('close')

    const { slides } = storeToRefs(useSlidesStore())

    const { exportJSON } = useExport()
    
    return {
      slides,
      exportJSON,
      close,
    }
  },
})
